import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
    },
  }));

function AutoFormLayout ( props ) {

    const { children, ...others } = props;

    const classes = useStyles();

    return (

        <div className={classes.root} {...others} >
            { children }
        </div>

    );
}

export default AutoFormLayout;

  